const property = {
  cssHeight: {
    seencTableHeader: '33px',
    seencTableRow: '42px',
  },
  cssBorderRadius: {
    seencDefault: '7px',
    seencDashboard: '16px',
  },
  cssPadding: {
    seencDefault: '8px 12px',
    seencMenuLogo: '12px',
  },
  cssGap: {
    seencDefault: 1,
  },
  muiFontSize: {
    default: 'body1',
  },
};

export default property;
